import React from 'react';

const ReferenceList = ({ references }) => {
  if (!references || references.length === 0) return null;

  return (
    <div className="health-references">
      <h3 className="health-references-title">References</h3>
      <ol className="health-references-list">
        {references.map((ref) => (
          <li key={ref.id} id={`ref-${ref.id}`} className="health-references-item">
            <span className="health-ref-number">[{ref.id}]</span>
            {ref.url ? (
              <a
                href={ref.url}
                target="_blank"
                rel="noopener noreferrer"
                className="health-ref-link"
              >
                {ref.text}
              </a>
            ) : (
              <span className="health-ref-text">{ref.text}</span>
            )}
          </li>
        ))}
      </ol>
    </div>
  );
};

export default ReferenceList;
